import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: number | null = null as any;

const currentSesionStateSlice = createSlice({
	name: 'currentSesionState',
	initialState,
	reducers: {
		setCurrentSesionState: (state, action: PayloadAction<number | null>) => {
			return action.payload;
		},
		resetCurrentSesionState: () => {
			return initialState;
		}
	}
});

export const { setCurrentSesionState, resetCurrentSesionState } = currentSesionStateSlice.actions;

export default currentSesionStateSlice.reducer;
